/**
 * リアル展示会_出展社_一覧画面の初期化
 */
export function initDxpoSuppliers() {
    initKanaButton();
}
/**
 * 50音ボタンの初期化
 */
function initKanaButton() {
    const elements = document.getElementsByClassName('dxpo-suppliers-kana-button');
    for (const element of elements) {
        const button = element;
        const index = button.dataset.index;
        button.addEventListener("click", () => {
            const elements = document.getElementsByClassName('dxpo-suppliers-list');
            for (const element of elements) {
                const div = element;
                const hidden = 'hidden';
                if (div.dataset.index == index) {
                    div.removeAttribute(hidden);
                }
                else if (!div.hasAttribute(hidden)) {
                    div.setAttribute(hidden, hidden);
                }
            }
        });
    }
}
